import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

export default function LatestStory() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <SectionHeading
        kicker="最新剧情"
        title="主篇剧情已走向圆满落幕"
        desc="成神大结局为唐三的完整成长线画上句点，最新剧情速览帮你快速掌握收尾阶段的来龙去脉。"
      />
      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="group relative min-h-[320px] overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=A%20radiant%20ascending%20hero%20bathed%20in%20divine%20golden%20light%20above%20misty%20floating%20mountains%2C%20soul%20rings%20glowing%20around%20him%2C%20chinese%20fantasy%20apotheosis%20ending%2C%20warm%20amber%20and%20cream%20tones%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20peaceful%20triumphant%20mood%2C%20high%20detail&width=1000&height=640&seq=latest-story&orientation=landscape"
            alt="唐三成就海神之位，斗罗大陆漫画大结局场景"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-fire-line" /> 完结篇速览
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
              成神与守护：主篇故事如何迎来大结局
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-background-100/85">
              海神之位、挚爱守护与大陆安宁，最终一战之后，唐三的成长之路画上圆满句点。
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center gap-4">
          <article className="rounded-lg border border-background-200 bg-background-100 p-6">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold uppercase tracking-wider text-accent-600">剧情速览</span>
              <span className="text-xs text-foreground-400">大结局</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              历经双生武魂觉醒、史莱克七怪聚首、魂师大赛扬名与海神九考历练，唐三最终在最终决战中战胜强敌，成就海神之位，以更强的力量守护挚爱与大陆安宁，为整个主篇故事画上圆满句号。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              想知道主篇的完整脉络？从剧情进展页按时间线回顾每一段关键转折。
            </p>
          </article>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Link
              to="/story"
              className="group flex items-center justify-between rounded-lg bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600"
            >
              <div>
                <p className="text-sm font-semibold">完整主线剧情</p>
                <p className="mt-0.5 text-xs text-background-100/80">六大阶段时间线</p>
              </div>
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/chapters"
              className="group flex items-center justify-between rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <div>
                <p className="text-sm font-semibold text-foreground-950">追更话数进度</p>
                <p className="mt-0.5 text-xs text-foreground-500">第几话速查</p>
              </div>
              <i className="ri-arrow-right-line text-primary-600 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}